<template>
  <topbar
    :titulo="$t('FINANCEIRO.PERIODO_FINANCEIRO')"
    :subtitulo="$t('FINANCEIRO.PERIODO_FINANCEIRO_COMO_USAR_PAGINA')"
    :breadcrumbs="breadcrumbs"
  >
    <template #header>
      <div class="d-flex justify-content-between ml-md-4 gap-1">
        <div></div>
        <b-button variant="info" @click="cadastrar" v-if="podeCadastrar">
          {{ $t('GERAL.CADASTRAR') }}
        </b-button>
      </div>
    </template>
  </topbar>
</template>
<script>
// Utils & Aux:
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import Permissoes from '@/components/mixins/permissoes';

export default {
  mixins: [Permissoes],
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('FINANCEIRO.FINANCEIRO') },
        { titulo: this.$t('FINANCEIRO.CAIXA') },
        { titulo: this.$t('FINANCEIRO.PERIODO_FINANCEIRO') },
      ],
    };
  },
  methods: {
    // FUNÇÕES AUXILIARES:
    cadastrar() {
      this.$emit('cadastrar', 'criarPeriodoFinanceiroLote');
    },
  },
};
</script>
